var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMianhezai(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4797"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 699",
    d: "M15.7812 6.96875H5.28365L1.6875 13.8635H12.5288L15.7812 6.96875Z",
    fill: "#C2C2C2",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 4795"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 687",
    d: "M8.75049 0L8.75049 10.2272",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 13",
    d: "M8.75 11.6812L6.81413 9.50026L10.6859 9.50026L8.75 11.6812Z",
    fill: "black"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMianhezai);
export default __webpack_public_path__ + "static/media/mianhezai.902675eacd8c27094036d8db3b3690ad.svg";
export { ForwardRef as ReactComponent };